import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { roseburgConfig } from "./data";

export default function RoseburgPage() {
  return <OregonCityPageTemplate config={roseburgConfig} />;
}